import { createApi } from '@reduxjs/toolkit/query/react';
import AppEnvironment from '../../environment/app-environment';
import { selexpApiBaseQuery } from './selexp-api-base-query';

export const AdminNotificationsTag = 'AdminNotifications';
export const userNotificationsTag = 'UserNotifications';

export const selexpNotifiApiDuck = createApi({
  reducerPath: 'APISelexpNotifi',
  baseQuery: (args, api, extraOptions) => selexpApiBaseQuery(args, { ...api, endpoint: AppEnvironment.selexpNotifiEndpoint! }, extraOptions),
  tagTypes: [AdminNotificationsTag, userNotificationsTag],
  endpoints: () => ({}),
  keepUnusedDataFor: 3600, // 1 hour
});
